import { useState } from "react";
import { Asset } from "../models/asset";
import { fetchUptimeAssets } from "../api/fetchAssets";

function useUptimeAssets() {
    const [uptimeAssets, setUptimeAssets] = useState<Asset[]>([]);

    const getUptimeAssets = async (assetIds: string[]) => {
        if(assetIds?.length) {
            const data = await fetchUptimeAssets(assetIds);
            setUptimeAssets([...uptimeAssets, ...data]);
        }
    }

    return { uptimeAssets, getUptimeAssets }
}

export default useUptimeAssets;